import React from 'react';
import { Table, TagChip } from 'vindi-ds-components';
import toBrl from '@utils/format_currency';

const columns = [
  {
    label: 'Cliente',
    align: 'left',
  },
  {
    label: 'Valor',
    align: 'right',
  },
  {
    label: 'Emissão',
    align: 'left',
  },
  {
    label: 'Vencimento',
    align: 'left',
  },
  {
    label: 'Notificações',
    align: 'left',
  },
  {
    label: 'Última visualização',
    align: 'left',
  },
];

function TableChargesPending({ listingData }) {
  return (
    <Table.Container>
      <Table.Head columns={columns} />
      <Table.Body>
        {listingData?.chargesPending.map((charge) => (
          <Table.Row key={charge.id}>
            <Table.Cell align='left'>
              {charge.customer_name}
            </Table.Cell>
            <Table.Cell align='right'>
              {charge.amount && toBrl(charge.amount)}
            </Table.Cell>
            <Table.Cell align='left'>
              {charge.created_at}
            </Table.Cell>
            <Table.Cell align='left'>
              {charge.due_at}
            </Table.Cell>
            <Table.Cell align='left'>
              <TagChip label={charge.notification} kind='attention' />
            </Table.Cell>
            <Table.Cell align='left'>
              {charge.seen_at || '-'}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Container>
  );
}

export default TableChargesPending;
